import type { Candidate, Choice } from "../types";

const CHOICES: { key: Choice; label: string }[] = [
  { key: "select", label: "Select" },
  { key: "skip", label: "Skip" },
  { key: "defer", label: "Defer" },
];

interface Props {
  candidate: Candidate;
  choice: Choice | undefined;
  onChoose: (id: string, choice: Choice) => void;
  onOpen: (id: string) => void;
  disabled: boolean;
}

export function CandidateCard({ candidate: c, choice, onChoose, onOpen, disabled }: Props) {
  return (
    <article className="card" data-choice={choice ?? ""}>
      {/* The whole body opens the detail page. The decision buttons sit outside
          it, so tapping Select can never be mistaken for tapping through. */}
      <button className="card-body" onClick={() => onOpen(c.id)}
              aria-label={`Details for ${c.ticker}`}>
      <div className="card-head">
        <span className="ticker">{c.ticker}</span>
        {c.company && <span className="company">{c.company}</span>}
        {c.riskVerdict && (
          <span className={`verdict ${c.riskVerdict}`}>
            {c.riskVerdict}
            {c.maxSizePct != null && ` ${c.maxSizePct}%`}
          </span>
        )}
      </div>

      <span className="screen-tag">{c.screen}</span>
      <p className="matched">{c.matched}</p>

      <dl className="rows">
        {c.thesis && (
          <div className="row">
            <dt>THESIS</dt>
            <dd>{c.thesis}</dd>
          </div>
        )}
        {c.bull && (
          <div className="row bull">
            <dt>BULL</dt>
            <dd>{c.bull}</dd>
          </div>
        )}
        {c.bear && (
          <div className="row bear">
            <dt>BEAR</dt>
            <dd>{c.bear}</dd>
          </div>
        )}
        {c.riskNote && (
          <div className="row">
            <dt>RISK</dt>
            <dd>{c.riskNote}</dd>
          </div>
        )}
        {/* Always shown when present. A screen's blind spots belong next to its
            findings, not in a footnote - otherwise a narrow signal reads as a
            broad endorsement. */}
        {c.notChecked && (
          <div className="row blind">
            <dt>UNSEEN</dt>
            <dd>{c.notChecked}</dd>
          </div>
        )}
      </dl>

      <span className="more">Details →</span>
      </button>

      <div className="choices" role="group" aria-label={`Decision for ${c.ticker}`}>
        {CHOICES.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            className="choice"
            data-c={key}
            aria-pressed={choice === key}
            disabled={disabled}
            onClick={() => onChoose(c.id, key)}
          >
            {label}
          </button>
        ))}
      </div>
    </article>
  );
}
